<div class="flex flex-col min-h-screen">
  <!-- 헤더 -->
  <app-header class="sticky top-0 z-50" />

  <!-- 메인 콘텐츠 (페이지에서 직접 컨테이너를 제어하도록 제약 해제) -->
  <main class="flex-1 bg-base-100 w-full">
    <router-outlet />
  </main>

  <!-- 푸터 -->
  <app-footer />
</div>
